import React from 'react';
import { useLocation } from 'wouter';
import { useDispatch, useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import List from '@mui/material/List';

import type { MenuEntry } from '../types/general';
import type { AppDispatch } from '../../store';
import localStorageAccess from '../helpers/localStorageAccess';
import authenticationSelector from '../../authentication/authenticationSelector';
import MenuItem from './MenuItem';
import { ColorBackgroundColor } from '../types/themeTypes';

type Props = {
  entries: MenuEntry[];
  showLogoutButton: boolean;
  theme: ColorBackgroundColor;
};

function Menu(props: Props) {
  const dispatch: AppDispatch = useDispatch();
  const [location, setLocation] = useLocation();
  const isAuthenticated = useSelector(authenticationSelector.isAuthenticated);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0px 24px 0px 8px',
        background: props.theme.background,
      }}
    >
      <List
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          padding: '0',
        }}
      >
        {props.entries.map((entry) => (
          <MenuItem key={entry.label} entry={entry} location={location} theme={props.theme} />
        ))}
      </List>
      {props.showLogoutButton && isAuthenticated && (
        <Container
          disableGutters
          sx={{
            flex: 0,
          }}
        >
          <Button
            variant='contained'
            onClick={() => {
              dispatch({ type: 'resetState' });
              localStorageAccess.removeJwtToken();
              setLocation(`/authentication?redirect=${location}`);
            }}
          >
            Logout
          </Button>
        </Container>
      )}
    </Container>
  );
}

export default Menu;
